import { render, staticRenderFns } from "./WithDropdownSlot.vue?vue&type=template&id=327e9c0b&scoped=true&"
import script from "./WithDropdownSlot.vue?vue&type=script&lang=js&"
export * from "./WithDropdownSlot.vue?vue&type=script&lang=js&"
import style0 from "./WithDropdownSlot.vue?vue&type=style&index=0&id=327e9c0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e9c0b",
  null
  
)

export default component.exports